import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { BaseMatManModal } from '@monorepo/shared/src/components/common/Modals';
import CommonFormInput from '../../../common/CommonFormInput';
import React, { useState } from 'react';

const t = (key, options?) => translate('teachingOrder', key, options);

const EditTeachingOrderNameModal = ({ onClose, onSave, name }) => {
  const classes = useStyles();

  const [customName, setCustomName] = useState(name);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(customName);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <BaseMatManModal
      leftButtonAction={onClose}
      rightButtonAction={handleSave}
      headerFontSize={'24px'}
      leftButtonText={t('cancel')}
      rightButtonText={t('saveChanges')}
      rightButtonProps={{ disabled: isSaving }}
    >
      <Typography>
        {t('editNameModalText1')}
        <Box component="span" className={classes.boldName}>
          {`"${name}"`}
        </Box>
        {t('editNameModalText2')}
      </Typography>
      <CommonFormInput
        onChange={(e) => setCustomName(e.target.value)}
        label={t('editNameInputTitle')}
        value={customName}
        className={classes.textInput}
      />
    </BaseMatManModal>
  );
};
const useStyles = makeStyles(() => ({
  boldName: {
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
  textInput: {
    marginTop: '.75rem',
  },
}));

export default EditTeachingOrderNameModal;
